<template>
  <section>
    <modal
      v-model="open"
      :before-close="closeModal"
      class="custom-modal"
      :footer="false"
    >
      <template #header>
        <a
          role="button"
          href="#"
          class="custom-modal__close"
          type="button"
          @click.prevent="closeModal"
        >
          <span class="mi mi-cross"></span>
        </a>
      </template>
      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Usługi dodatkowe nie zostały zapisane.</h2>
        <p>Jeśli miałeś wybrane usługi dodatkowe w zamówieniu, dodaj je ponownie.</p>
      </div>
      <div class="custom-modal__controls">
        <btn @click="closeModal" class="btn btn-primary">Rozumiem</btn>
      </div>
    </modal>
  </section>
</template>

<script>
export default {
  name: 'ConfectionResetModal',
  props: ['open'],
  methods: {
    closeModal() {
      this.$emit('update:open', false);
    },
  },
};
</script>

<style scoped>
</style>
